import { render, staticRenderFns } from "./FCheckboxList.vue?vue&type=template&id=66f0e87c&"
import script from "./FCheckboxList.vue?vue&type=script&lang=js&"
export * from "./FCheckboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FCheckboxList.vue"
export default component.exports